import { useContext } from "react";
import { useDraggable } from "@dnd-kit/core";
import { MainContext } from "../../App";
import functions from "../../utilities/functions";
import { getSelectedVariantsPrice, normalizeSelectedVariants } from "../../utilities/selectedVariants";
import DragHandleIcon from "../../icons/DragHandleIcon";

function Product({ product, i, isFlowDragEnabled, dragData }) {
  const { user, setVariantsPopup, editQty, setPopupVisible, setPopupData } = useContext(MainContext);
  const isAdmin = parseInt(user?.role?.admin) === 1;
  const canEditPrices = isAdmin || parseInt(user?.role?.waiter_permissions?.prices_edit?.edit) === 1;
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: "cart-product-" + product.index,
    data: dragData,
    disabled: !isFlowDragEnabled,
  });

  const cloneProductForEdit = (sourceProduct) => ({
    ...sourceProduct,
    selectedVariants:
      sourceProduct.selectedVariants === false
        ? false
        : JSON.parse(JSON.stringify(sourceProduct.selectedVariants || [])),
    selectedIngredients:
      sourceProduct.selectedIngredients === false
        ? false
        : JSON.parse(JSON.stringify(sourceProduct.selectedIngredients || [])),
  });

  const handleClick = () => {
    setVariantsPopup({
      product: cloneProductForEdit(product),
      index: product.index,
      fromCartEdit: true,
    });
  };

  const getPrice = (price) => {
    return (parseFloat(price) || 0) + getSelectedVariantsPrice(product.selectedVariants);
  };

  return (
    <div key={i} className="cart-product-row">
      <div className={"list-button vertical" + (isDragging ? " is-dragging" : "")}>
        <div className="buttons-group full text-box">
          {isFlowDragEnabled && (
            <button
              ref={setNodeRef}
              className="btn btn-tertiary btn-square drag-handle"
              style={{ opacity: isDragging ? 0.5 : 1 }}
              {...listeners}
              {...attributes}
            >
              <DragHandleIcon />
            </button>
          )}
          <button onClick={() => handleClick()} className="product-name">
            <div>
              {product.name}
              <div className="small">{functions.formatEuro(getPrice(product.price))}</div>
            </div>
            {(normalizeSelectedVariants(product.selectedVariants) || []).map((vc, vcIdx) => {
              const variants = (vc.variants || []).filter(v => v.qty > 0);
              const variants2 = (vc.variants2 || [])
                .filter(v => v.qty > 0 || (vc.force_mono == 1 && v.qty == 0))
                .sort((a, b) => (a.qty === 0 ? -1 : 1) - (b.qty === 0 ? -1 : 1));
              const products = (vc.products || []).filter(v => v.qty > 0);
              const products2 = (vc.products2 || []).filter(v => v.qty > 0);
              if (!variants.length && !variants2.length && !products.length && !products2.length) return null;
              return (
                <div key={vcIdx} className="small">
                  <div className="bold">{vc.name}</div>
                  {variants.map((v, j) => <div key={j}>{v.qty}X {v.name}</div>)}
                  {variants2.map((v, j) => (
                    <div key={j} className={v.qty <= 0 ? "text-error" : ""}>
                      {vc.force_mono == 1 && v.qty == 0 ? "No " : v.qty + "X "}{v.name}
                    </div>
                  ))}
                  {products.map((v, j) => <div key={j}>{v.qty}X {v.name}</div>)}
                  {products2.map((v, j) => <div key={j}>{v.qty}X {v.name}</div>)}
                </div>
              );
            })}
            {Array.isArray(product.selectedIngredients) &&
              product.selectedIngredients.filter(i => !i.selected).map((ing, j) => (
                <div key={j} className="small text-error">No {ing.name}</div>
              ))}
            <div className="small" dangerouslySetInnerHTML={{ __html: product.notes }} />
          </button>
          <div className="cart-line-actions">
            <div className="cart-line-price">
              {canEditPrices ? (
                <button
                  className="price-edit-trigger"
                  onClick={() => {
                    setPopupData({ index: product.index });
                    setPopupVisible("priceEdit");
                  }}
                >
                  {functions.formatEuro(getPrice(product.price))}
                </button>
              ) : (
                <span>{functions.formatEuro(getPrice(product.price))}</span>
              )}
            </div>
            <div className="plus_minus_container cart-qty-controls">
              <button className="btn btn-primary btn-square" onClick={() => editQty(product.index, "minus")}>
                &#8722;
              </button>
              <div className="cart-qty-value">{product.qty}</div>
              <button className="btn btn-primary btn-square" onClick={() => editQty(product.index, "plus")}>
                &#43;
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Product;
